import { ContainerV2, H1, IconPillTag } from "../../Atoms";
import { formatarMoedaBRL } from "../../../utils/masks";
import { useBatchCreatedAppointments } from "./useBatchCreatedAppointments";
import { CreatedAppointmentCard } from "./Components/CreatedAppointmentCard";

const iconeLoteImportado = (
  <svg
    width="5"
    height="5"
    viewBox="0 0 5 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.83317 3.31246L0.958171 2.43746L0.666504 2.72913L1.83317 3.89579L4.33317 1.39579L4.0415 1.10413L1.83317 3.31246Z"
      fill="#38b449"
    />
  </svg>
);

export const BatchCreatedAppointments = () => {
  const {
    stepIndicator,
    agendamentos,
    tipoAtendimento,
    valorTotal,
    servico,
    identificador,
    navigateHome,
    navigateToMeusAgendamentos,
  } = useBatchCreatedAppointments();

  return (
    <ContainerV2
      backButton={{
        title: "Voltar ao início",
        icon: <></>,
        onClick: navigateHome,
        variant: "outline",
      }}
      nextButton={{
        title: "Ver meus agendamentos",
        onClick: navigateToMeusAgendamentos,
      }}
    >
      {stepIndicator}

      <div className="flex flex-col gap-6 pt-8 md:flex-row md:items-start md:justify-between">
        <div>
          <IconPillTag color="#38b449" icon={iconeLoteImportado}>
            Lote importado
          </IconPillTag>
          <H1 className="mb-2 mt-4">
            {agendamentos.length} agendamentos criados
          </H1>
          <p className="font-['Mulish'] text-lg text-[#666]">
            Após a quitação das faturas, a data e o horário de cada vistoria
            poderão ser definidos.
          </p>
        </div>

        {valorTotal !== undefined && (
          <div className="mx-auto flex w-fit flex-col items-center gap-2.5 rounded-[10px] border border-solid border-[#e5e5ea] bg-white p-[15px] text-center md:mx-0 md:w-auto md:items-end md:text-right">
            <span className="font-['Mulish'] text-xs text-[#20332f]">
              Total do lote
            </span>
            <span className="font-['Mulish'] text-2xl font-extrabold text-[#20332f]">
              {formatarMoedaBRL(valorTotal)}
            </span>
          </div>
        )}
      </div>

      <div className="mt-8 flex max-h-[949px] flex-col gap-4 overflow-y-auto">
        {agendamentos.map((agendamento) =>
          tipoAtendimento ? (
            <CreatedAppointmentCard
              key={agendamento.uuid}
              agendamento={agendamento}
              tipoAtendimento={tipoAtendimento}
              identificador={identificador}
              servico={servico}
            />
          ) : null,
        )}
      </div>
    </ContainerV2>
  );
};
